export const EMPTY_EDITOR_HTML_VALUES = [
  '<p><br></p>',
  '<p></p>',
  '<h1><br></h1>',
  '<h1></h1>',
  '<h2><br></h2>',
  '<h2></h2>',
  '<h3><br></h3>',
  '<h3></h3>',
];

export function isTextEditorValueEmpty(
  value: string | null | undefined,
): boolean {
  if (!value) return true;
  return EMPTY_EDITOR_HTML_VALUES.includes(value);
}

export function hasTextEditorValue(
  value: string | null | undefined,
): value is string {
  return !isTextEditorValueEmpty(value);
}
